import React, {useState, useEffect} from 'react';
import {
  View,
  Text,
  StyleSheet,
  Modal,
  TouchableOpacity,
  ScrollView,
} from 'react-native';
import {Colors} from '../../../constants/Colors';

interface IModalFilterOrdersProps {
  visible: boolean;
  onRequestClose: () => void;
  currentDiasPedido?: number;
  currentType?: string;
  currentStatus?: string;
  returnFilter: (filter: {
    diasPedido: number;
    type: string;
    status: string;
  }) => void;
  cleanFilter: () => void;
  hasType?: boolean;
  hasStatus?: boolean;
  hasDiasPedido?: boolean;
  status?: Array<any>;
}

const ModalFilterOrders: React.FC<IModalFilterOrdersProps> = ({
  visible,
  onRequestClose,
  currentDiasPedido = 30,
  currentType = 'all',
  currentStatus = 'all',
  returnFilter,
  cleanFilter,
  hasType = false,
  hasStatus = false,
  hasDiasPedido = false,
  status = [],
}) => {
  const [selectedDiasPedido, setSelectedDiasPedido] = useState(currentDiasPedido);
  const [selectedType, setSelectedType] = useState(currentType);
  const [selectedStatus, setSelectedStatus] = useState(currentStatus);

  useEffect(() => {
    setSelectedDiasPedido(currentDiasPedido);
    setSelectedType(currentType);
    setSelectedStatus(currentStatus);
  }, [currentDiasPedido, currentType, currentStatus]);

  const diasPedidoOptions = [
    {label: '7 dias', value: 7},
    {label: '15 dias', value: 15},
    {label: '30 dias', value: 30},
    {label: '60 dias', value: 60},
    {label: '90 dias', value: 90},
  ];

  const todosStatus = [
      { id: 'CANCELADO', label: 'Cancelado', origin: 'CANCELADO' },
      { id: 'PEDIDO_CANCELADO', label: 'Pedido Cancelado', origin: 'PEDIDO CANCELADO' },
      { id: 'PEDIDO_NAO_FATURADO', label: 'Pedido Nao Faturado', origin: 'PEDIDO NAO FATURADO' },
      { id: 'PEDIDO_NOTA_CANCELADA', label: 'Pedido Nota Cancelada', origin: 'PEDIDO NOTA CANCELADA' },
      { id: 'PEDIDO_RETORNADO', label: 'Pedido Retornado', origin: 'PEDIDO RETORNADO' },
      { id: 'RETORNADO/DEVOLVIDO', label: 'Retornado/Devolvido', origin: 'RETORNADO/DEVOLVIDO' },
      { id: 'PARCIALMENTE_ENTREGUE', label: 'Parcialmente Entregue', origin: 'PARCIALMENTE ENTREGUE' },
      { id: 'PEDIDO_PARCIALMENTE_RECUSADO', label: 'Pedido Parcialmente Recusado', origin: 'PEDIDO PARCIALMENTE RECUSADO' },
      { id: 'PEDIDO_PARCIALMENTE_RETORNADO', label: 'Pedido Parcialmente Retornado', origin: 'PEDIDO PARCIALMENTE RETORNADO' },
      { id: 'PEDIDO_ENTREGUE', label: 'Pedido Entregue', origin: 'PEDIDO ENTREGUE' },
      { id: 'FINANCEIRO_APROVADO', label: 'Financeiro Aprovado', origin: 'FINANCEIRO APROVADO' },
      { id: 'PEDIDO_FATURADO', label: 'Pedido Faturado', origin: 'PEDIDO FATURADO' },
      { id: 'PEDIDO_EM_SEPARACAO', label: 'Pedido Em Separacao', origin: 'PEDIDO EM SEPARACAO' },
      { id: 'PEDIDO_EM_TRANSITO', label: 'Pedido Em Transito', origin: 'PEDIDO EM TRANSITO' },
      { id: 'FATURAMENTO_PENDENTE', label: 'Faturamento Pendente', origin: 'FATURAMENTO PENDENTE' },
      { id: 'FINANCEIRO_NAO_APROVADO', label: 'Pedido em Processamento', origin: 'FINANCEIRO NAO APROVADO' },
      { id: 'PEDIDO_EM_PROCESSAMENTO', label: 'Pedido Em Processamento', origin: 'PEDIDO EM PROCESSAMENTO' },
      { id: 'PEDIDO_CONFIRMADO', label: 'Pedido Confirmado', origin: 'PEDIDO CONFIRMADO' }
  ];

  const formattedStatus = status.map(s => {
    const found = todosStatus.find(ts => ts.origin === s);
    return found ? { label: found.label, value: found.id } : { label: s, value: s };
  });

  const typeOptions = [
    {label: 'Todos', value: 'all'},
    {label: 'Bonificação', value: 'bonificacao'},
    {label: 'Compra', value: 'compra'},
  ];

  const handleApplyFilter = () => {
    returnFilter({
      diasPedido: selectedDiasPedido,
      type: selectedType,
      status: selectedStatus,
    });
    onRequestClose();
  };

  const handleCleanFilter = () => {
    setSelectedDiasPedido(30);
    setSelectedType('all');
    setSelectedStatus('all');
    cleanFilter();
    onRequestClose();
  };

  return (
    <Modal
      visible={visible}
      animationType="slide"
      transparent={true}
      onRequestClose={onRequestClose}>
      <View style={styles.overlay}>
        <View style={styles.container}>
          <View style={styles.header}>
            <Text style={styles.title}>Filtrar Pedidos</Text>
            <TouchableOpacity onPress={onRequestClose}>
              <Text style={styles.closeButton}>✕</Text>
            </TouchableOpacity>
          </View>

          <ScrollView showsVerticalScrollIndicator={false}>
            {hasDiasPedido && (
              <View style={styles.section}>
                <Text style={styles.sectionTitle}>Período</Text>
                {diasPedidoOptions.map(option => (
                  <TouchableOpacity
                    key={option.value}
                    style={[
                      styles.option,
                      selectedDiasPedido === option.value && styles.optionSelected,
                    ]}
                    onPress={() => setSelectedDiasPedido(option.value)}>
                    <Text
                      style={[
                        styles.optionText,
                        selectedDiasPedido === option.value &&
                          styles.optionTextSelected,
                      ]}>
                      {option.label}
                    </Text>
                    {selectedDiasPedido === option.value && (
                      <View style={styles.radioSelected} />
                    )}
                  </TouchableOpacity>
                ))}
              </View>
            )}

            {hasType && (
              <View style={styles.section}>
                <Text style={styles.sectionTitle}>Tipo de Pedido</Text>
                {typeOptions.map(option => (
                  <TouchableOpacity
                    key={option.value}
                    style={[
                      styles.option,
                      selectedType === option.value && styles.optionSelected,
                    ]}
                    onPress={() => setSelectedType(option.value)}>
                    <Text
                      style={[
                        styles.optionText,
                        selectedType === option.value && styles.optionTextSelected,
                      ]}>
                      {option.label}
                    </Text>
                    {selectedType === option.value && (
                      <View style={styles.radioSelected} />
                    )}
                  </TouchableOpacity>
                ))}
              </View>
            )}

            {hasStatus && status.length > 0 && (
              <View style={styles.section}>
                <Text style={styles.sectionTitle}>Status</Text>
                <TouchableOpacity
                  style={[
                    styles.option,
                    selectedStatus === 'all' && styles.optionSelected,
                  ]}
                  onPress={() => setSelectedStatus('all')}>
                  <Text
                    style={[
                      styles.optionText,
                      selectedStatus === 'all' && styles.optionTextSelected,
                    ]}>
                    Todos
                  </Text>
                  {selectedStatus === 'all' && (
                    <View style={styles.radioSelected} />
                  )}
                </TouchableOpacity>
                {formattedStatus.map((item, index) => (
                  <TouchableOpacity
                    key={index}
                    style={[
                      styles.option,
                      selectedStatus === item.value && styles.optionSelected,
                    ]}
                    onPress={() => setSelectedStatus(item.value)}>
                    <Text
                      style={[
                        styles.optionText,
                        selectedStatus === item.value &&
                          styles.optionTextSelected,
                      ]}>
                      {item.label}
                    </Text>
                    {selectedStatus === item.value && (
                      <View style={styles.radioSelected} />
                    )}
                  </TouchableOpacity>
                ))}
              </View>
            )}
          </ScrollView>

          <View style={styles.footer}>
            <TouchableOpacity
              style={styles.buttonClean}
              onPress={handleCleanFilter}>
              <Text style={styles.buttonCleanText}>Limpar</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.buttonApply}
              onPress={handleApplyFilter}>
              <Text style={styles.buttonApplyText}>Aplicar</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end',
  },
  container: {
    backgroundColor: 'white',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '80%',
    paddingBottom: 20,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: Colors.GrayPallete.lightgrayThree + '30',
  },
  title: {
    fontSize: 18,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
  },
  closeButton: {
    fontSize: 24,
    color: Colors.GrayPallete.lightgrayThree,
  },
  section: {
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  sectionTitle: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
    marginBottom: 12,
  },
  option: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    marginBottom: 8,
    backgroundColor: Colors.GrayPallete.lightgrayThree + '10',
  },
  optionSelected: {
    backgroundColor: Colors.RedPallete.red + '15',
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
  },
  optionText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  optionTextSelected: {
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.RedPallete.red,
  },
  radioSelected: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: Colors.RedPallete.red,
  },
  footer: {
    flexDirection: 'row',
    paddingHorizontal: 20,
    paddingTop: 16,
    gap: 12,
  },
  buttonClean: {
    flex: 1,
    paddingVertical: 14,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
    alignItems: 'center',
  },
  buttonCleanText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.RedPallete.red,
  },
  buttonApply: {
    flex: 1,
    paddingVertical: 14,
    borderRadius: 8,
    backgroundColor: Colors.RedPallete.red,
    alignItems: 'center',
  },
  buttonApplyText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'white',
  },
});

export default ModalFilterOrders;